export { RiveAnimationDirective } from './rive-animation.directive';
